import { makeStyles } from '@material-ui/core/styles';
var getIconColor = function (variant, theme) {
    switch (variant) {
        case 'error':
        case 'search':
            return theme.palette.error.dark;
        case 'warning':
            return theme.palette.warning.dark;
        case 'info':
        case 'confirm':
            return theme.palette.info.dark;
        case 'notification':
            return theme.palette.warning.dark;
        default:
            return theme.palette.primary.main;
    }
};
export default makeStyles(function (theme) { return ({
    icon: function (props) { return ({
        color: getIconColor(props.variant, theme),
        marginRight: theme.spacing(1),
        fontSize: '24px',
    }); },
    content: {
        padding: theme.spacing(0, 3),
    },
    cancelBtn: {
        marginRight: theme.spacing(2),
    },
}); });
